<template>
<div class="dialogPage">
    <el-pagination
        background
        @current-change="handleSizeChange"
        :current-page.sync="page.pageNumber"
        :page-size="page.pageSize"
        :pager-count="11"
        layout="prev, pager, next, jumper"
        :total="total">
    </el-pagination>
</div>
</template>
<!--layout="total, prev, pager, next, jumper"-->

<script>
import {mapActions} from 'vuex'

export default {
    name: 'dialogPage',
    props: ['total'],
    data() {
        return {
            page: {
                page: 1,
                pageSize: 5
            }
        }
    },
    mounted() {
        this.setDialogPage(this._.cloneDeep(this.page))
    },
    methods: {
        initDialogPage() {
            this.page.page = 1
            this.setDialogPage({page: 1, pageSize: 10})
        },
        handleSizeChange(val) {
            this.page.page = val
            this.setDialogPage(this._.cloneDeep(this.page))
            this.$emit('getList')
        },
        ...mapActions([
            'setDialogPage'
        ])
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";

.dialogPage {
    margin-top: 20px;
    @include flexBox(center)
}
</style>
